import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";

export const ADD_USER_TO_DEPARTMENT = createActionType(
  "ADD_USER_TO_DEPARTMENT"
);
export const GET_USERS_FROM_DEPARTMENT = createActionType(
  "GET_USERS_FROM_DEPARTMENT"
);
export const GET_USER_DEPARTMENT_BY_ID = createActionType(
  "GET_USER_DEPARTMENT_BY_ID"
);
export const EDIT_USER_TO_DEPARTMENT = createActionType(
  "EDIT_USER_TO_DEPARTMENT"
);
export const REMOVE_USER_FROM_DEPARTMENT = createActionType(
  "REMOVE_USER_FROM_DEPARTMENT"
);

export const addUserToDepartment = (data: any) =>
  createAsyncAction(
    ADD_USER_TO_DEPARTMENT,
    "/grouping_user/add_user_to_department",
    "post",
    data,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const getAllGrouping = () =>
  createAsyncAction(
    GET_USERS_FROM_DEPARTMENT,
    "/grouping_user/get_users_in_departments",
    "get",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const getUserFromDepartmentById = (id: any) =>
  createAsyncAction(
    GET_USERS_FROM_DEPARTMENT,
    `/grouping_user/get_user_department_by_id/${id}`,
    "get",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const editUserDepartment = (id: any, data: any) =>
  createAsyncAction(
    EDIT_USER_TO_DEPARTMENT,
    `/grouping_user/edit_user_department/${id}`,
    "put",
    data,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const removeGrouing = (id: any) =>
  createAsyncAction(
    REMOVE_USER_FROM_DEPARTMENT,
    `/grouping_user/remove_user_from_department/${id}`,
    "delete",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );
